<template>
  <div class="content-slideshow-container">
    <div
      ref="slideshow"
      class="content-slideshow"
    >
      <slot />
    </div>
    <div class="container px-2">
      <div class="row">
        <div class="col-xs-12 col-sm-4 pr-sm-3" />
        <div class="col-xs-12 col-sm-8 pl-sm-3">
          <div class="slideshow__meta">
            <div class="slideshow__controls">
              <button
                class="slide-control button button-compact"
                @click="prevSlide()"
              >
                <icon name="chevron-left" />
              </button>
              <button
                class="slide-control button button-compact ml-1"
                @click="nextSlide()"
              >
                <icon name="chevron-right" />
              </button>
            </div>
            <div class="slideshow__description">
              {{ description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Flickity from 'flickity-imagesloaded'
import { Icon } from 'zv-components'

export default {
  name: 'ContentSlideshow',
  components: { Icon },
  props: {
    cellClass: {
      type: String,
      default: '.content__slide',
    },
    imageDescriptions: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    f: null,
    slideIndex: 0,
  }),
  computed: {
    description () {
      return this.imageDescriptions[this.slideIndex]
    },
  },
  mounted () {
    this.f = new Flickity(this.$refs.slideshow, {
      imagesLoaded: true,
      lazyLoad: 2,
      cellSelector: this.cellClass,
      cellAlign: 'left',
      pageDots: false,
      wrapAround: true,
      prevNextButtons: false,
      setGallerySize: false,
      resize: true,
    })

    this.f.on('change', this.setSlideIndex)
    this.f.on('settle', () => {
      this.f.resize()
    })
    this.f.on('ready', () => {
      this.f.resize()
    })
  },
  beforeDestroy () {
    this.f.off('change', this.setSlideIndex)
    this.f.destroy()
  },
  methods: {
    setSlideIndex () {
      this.slideIndex = this.f.selectedIndex
    },
    nextSlide () {
      this.f.next(true)
    },
    prevSlide () {
      this.f.previous(true)
    },
  },
}
</script>
